import React, { Component } from 'react'
import styled from 'styled-components';
import { Gutter, BlueButton } from '../stylesheets/components';
import { withRouter } from 'react-router';
import { RED_COLOR } from '../constants/defaults';
import { Logo } from '../components';
import media from '../stylesheets/media';

const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 7;

  ${media.mobileSmall`
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
  `}
`;

const Title = styled.div`
  font-family: "Heldane Display";
  font-size: 3.4em;
  line-height: 1.1;
  color: ${RED_COLOR};

  ${media.smallDesktop`

    font-size: 3.2em;
  `}

  ${media.padLandscape`

    font-size: 3.0em;
  
  `}
  ${media.mobileSmall`

    font-size: 2.0em;
  
  `}
`;

const Description = styled.div`
  
  font-family: "Heldane Display";
  width: 500px;
  line-height: 1.2;
  font-size:1.6em;
  color: white;

  ${media.padLandscape`
    width: calc(50% - 20px);
    font-size: 1.3em;
  
  `}

  ${media.mobileSmall`
    width: calc(100% - 20px);
    font-size:1.2em;
  `}
  
`;

const CenterWrapper = styled.div`
  
  position: absolute;
  left: 50%;
  top: calc(50% - 15px);
  transform: translate(-50%, -50%);
  
  ${media.mobileSmall`
    top: 20px;
    transform: translate(-50%,0);
  `}
  
  div.wrapper { 
    position: relative;
    width: 1024px;
    margin: 0 auto;

        
    ${media.padLandscape`

      width: calc(100vw - 60px);  

    `}
  }

  h1 {
    font-family: "Source Sans Pro";
    font-weight: 600;
    color: white;
  }

  div.desc-area {
    display: flex;
    justify-content: space-between;
  
    ${media.mobileSmall`
      display: block;
    `}
  }

  div.btn-area {
    display: flex;
  }
`;

const Byline = styled.div`
  width: 400px;
  color: white;
  font-size:0.9em;
  ${media.mobileSmall`
    display: block;
    margin: 50px 0;
  `}
`;

const CenterContainer = styled.div`
  width: 1024px;
  margin: 0 auto;

  ${media.padLandscape`

    width: calc(100vw - 60px);  
  
  `}

`;

const LineWrapper = styled.div`
  position: relative;
  hr.right-line {
    position: absolute;
    left: 120px;
    top: 2px;
    width: calc(100vw - 122px);
    border: none;
    border-bottom: 1px solid ${RED_COLOR};
  }
   hr.left-line {
    position: absolute;
    left: -100vw;
    top: 2px;
    width: calc(100vw - 8px);
    border: none;
    border-bottom: 1px solid ${RED_COLOR};
  }
`;


class Intro extends Component {

  handleClick(e){
    this.props.history.push('/contribute');
  }

  render() {
    return (
      <Container>
        <CenterWrapper>
          <div>
            <div className="wrapper">
            <svg width="47" height="42" viewBox="0 0 47 42" fill="none">
                <path d="M45.7751 0H1.22506V5.545H0.185059V8.825C0.185484 9.89659 0.552467 10.9358 1.22506 11.77V42H45.7751V11.77C46.4477 10.9358 46.8146 9.89659 46.8151 8.825V5.545H45.7751V0ZM3.22506 2H43.7751V5.555H3.22506V2ZM44.8151 8.825C44.8151 9.54639 44.5285 10.2382 44.0184 10.7483C43.5083 11.2584 42.8164 11.545 42.0951 11.545C41.3737 11.545 40.6818 11.2584 40.1717 10.7483C39.6616 10.2382 39.3751 9.54639 39.3751 8.825V7.545H44.8151V8.825ZM37.3751 8.825V9.65C37.3386 10.6752 36.9057 11.6463 36.1675 12.3588C35.4293 13.0712 34.4435 13.4693 33.4176 13.4693C32.3917 13.4693 31.4058 13.0712 30.6676 12.3588C29.9294 11.6463 29.4965 10.6752 29.4601 9.65V7.545H37.3751V8.825ZM27.4601 9.65C27.4236 10.6752 26.9907 11.6463 26.2525 12.3588C25.5143 13.0712 24.5285 13.4693 23.5026 13.4693C22.4767 13.4693 21.4908 13.0712 20.7526 12.3588C20.0144 11.6463 19.5815 10.6752 19.5451 9.65V7.545H27.4601V9.65ZM9.62506 8.825V7.545H17.5401V9.65C17.559 10.1815 17.4706 10.7114 17.2802 11.2081C17.0898 11.7047 16.8014 12.1579 16.432 12.5406C16.0627 12.9234 15.62 13.2277 15.1304 13.4356C14.6409 13.6435 14.1144 13.7507 13.5826 13.7507C13.0507 13.7507 12.5243 13.6435 12.0347 13.4356C11.5451 13.2277 11.1025 12.9234 10.7331 12.5406C10.3638 12.1579 10.0753 11.7047 9.88491 11.2081C9.69454 10.7114 9.60616 10.1815 9.62506 9.65V8.825ZM2.18506 8.825V7.545H7.62506V8.825C7.62506 9.54639 7.33849 10.2382 6.82839 10.7483C6.31829 11.2584 5.62645 11.545 4.90506 11.545C4.18367 11.545 3.49183 11.2584 2.98173 10.7483C2.47163 10.2382 2.18506 9.54639 2.18506 8.825ZM27.4601 40H19.5401V26.75H27.4601V40ZM29.4601 40V24.75H17.5401V40H3.22506V13.23C4.06929 13.5596 4.99098 13.6372 5.87845 13.4535C6.76591 13.2698 7.58104 12.8326 8.22506 12.195C8.67669 13.1437 9.3715 13.9559 10.2388 14.549C11.1062 15.1421 12.1151 15.495 13.163 15.5717C14.211 15.6484 15.2605 15.4462 16.205 14.9857C17.1494 14.5252 17.9551 13.8228 18.5401 12.95C19.0829 13.7679 19.8196 14.4387 20.6846 14.9028C21.5496 15.3669 22.5159 15.6098 23.4976 15.6098C24.4792 15.6098 25.4455 15.3669 26.3105 14.9028C27.1755 14.4387 27.9122 13.7679 28.4551 12.95C29.0382 13.8302 29.8451 14.5394 30.7929 15.0048C31.7407 15.4702 32.7953 15.6749 33.8484 15.5981C34.9015 15.5212 35.9151 15.1655 36.7853 14.5675C37.6555 13.9694 38.3509 13.1506 38.8001 12.195C39.4441 12.8326 40.2592 13.2698 41.1467 13.4535C42.0341 13.6372 42.9558 13.5596 43.8001 13.23V40H29.4601Z" fill="white"/>
                <path d="M5.73999 33.2649H14.74V24.7649H5.73999V33.2649ZM7.73999 26.7649H12.74V31.2649H7.73999V26.7649Z" fill={RED_COLOR} />
                <path d="M32.24 33.2649H41.24V24.7649H32.24V33.2649ZM34.24 26.7649H39.24V31.2649H34.24V26.7649Z" fill={RED_COLOR}/>
              </svg>
            </div>
            <Gutter h={5} />
            <LineWrapper>
              <hr className="left-line" />
              <hr className="right-line" />
              <div className="wrapper">
                <h1>
                  wesurvived.nyc
                </h1>
              </div>
            </LineWrapper>
            <Gutter h={20} />

            <CenterContainer>
              <Title>
                Dear New Yorkers,<br/>
                <span className="white">Do not let small businesses close down!</span><br/>
                We are <span className="white">identifying neighborhood changes and collecting stories</span> that show the importance of small businesses in NYC.
              </Title>
              <Gutter h={20} />
              <div className="desc-area">

                <Description>
                  Please help identify neighborhood changes and contribute your memories about beloved places! It will help protect small businesses from <span className="white">massive neighborhood changes</span> and advocate for commercial rent stabilization.<br/><br/>                  
                  <div className="btn-area">
                    <BlueButton selected={true} onClick={this.handleClick.bind(this)}>
                      Let's Do That!
                    </BlueButton>
                  </div>
                </Description>
                <Byline>
                  A Project by<br />
                  <b>Wonyoung So, MIT DUSP</b><br/>
                  <br />
                  In collaboration with <br />
                  <b>Anti Eviction Mapping Project NYC</b><br/>
                  <b>Data + Feminism Lab, MIT</b><br />
                  <b>Andrew Rebatta, <i>Associate Curator at <br/>
                  the Museum of Chinese in America</i></b><br/><br/>

                  <a href="https://dataplusfeminism.mit.edu">
                    <img src="/assets/dflogo.svg" alt="Data + Feminism Lab, MIT" />
                  </a>
                </Byline>
              </div>

            </CenterContainer>
          </div>
        </CenterWrapper>      
      </Container>
    )
  }
}

export default withRouter(Intro);